import { clsx } from "clsx";
import { twMerge } from "../../../tailwind.config";

export const cn = (
  ...inputs: Array<
    | string
    | undefined
    | null
    | false
    | Record<string, boolean | null | undefined>
  >
): string => {
  return twMerge(clsx(inputs));
};
